import { getAuthHeader } from "src/utils/authCookieParser";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import goto from "src/pageDefinitions/goto";

export const setTelehealthAuthentication = async () => {
  // This action is a temporary solution to fix the user experience
  // necessary due to tight time constraints for the 503a transtion
  // Follow up work to clean up with a better solution will be done here:
  // https://noomhq.atlassian.net/browse/HC-4797
  getAuthHeader();

  const surveyAnswers = getSurveyAnswers();

  const { pdLifting } = surveyAnswers;

  if (pdLifting) {
    // Navigate back to the refill flow
    goto.telehealthEnrollmentSetup();
  }
};
